<template>
  <v-row justify="center">
    <v-col cols="12" style="max-width:680px">
      <v-sheet class="pt-6">
        <v-row wrap>
          <v-col cols="12">
            <h1 class="display-2 font-weight-bold d-inline-block mr-4"
              >Our Community</h1
            >
          </v-col>
        </v-row>
        <v-row wrap>
          <v-col cols="12">
            <Markdown
              v-if="getShopDetail('Minimart Community Intro').length"
              class="community-text title"
              :source="getShopDetail('Minimart Community Intro')"
            />
          </v-col>
          <CommunityMembersList />
        </v-row>
        <v-divider class="my-6"></v-divider>

        <v-row>
          <v-col cols="auto">
            <v-btn large dark depressed color="blue darken-1" to="/signup"
              >Signup for a Shop</v-btn
            >
          </v-col>
          <v-col cols="auto">
            <v-btn large dark outlined color="blue darken-1" to="/"
              >Back to the Home Page</v-btn
            ></v-col
          >
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import Markdown from '@/components/Markdown'
import { mapGetters } from 'vuex'
import CommunityMembersList from '@/components/CommunityMembersList'

export default {
  name: 'CommunityView',
  meta() {
    return {
      title: 'Minimart | Community - A wide variety of food makers.',
      meta: [
        {
          name: 'description',
          content:
            'From bagels to chili oil, burgers to fresh roasted coffee, we power food makers of all styles across the U.S.',
        },
      ],
    }
  },
  components: {
    CommunityMembersList,
    Markdown,
  },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
@import '@/scss/variables.scss';

.community-text {
  color: rgb(30, 30, 30);
  font-family: $body-font-family;
  line-height: 1.2;
  &.markdown-body {
    h1,
    h2,
    h3 {
      margin-bottom: 0;
      margin-top: 0;
    }
  }
  ul {
    padding-left: 0;
    margin-left: 0;
  }
  li {
    list-style: none;
    line-height: 1.6;
  }
}
</style>
